import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { config } from '~/constants/config';
import appendStyles from '~/services/appendStyles';
import App from '@/App';

import styles from '~/style.scss';

const billyStarter = () => {
  appendStyles.render({ href: `${config.ROOT}/style.min.css`, type: 'text/css', rel: 'stylesheet'}, () => {
    const $container = document.createElement('div');
    document.body.insertBefore($container, document.body.firstChild);
    ReactDOM.render(<App />, $container);
  });
}

window.onload = billyStarter;


// WEBPACK FOOTER //
// ./src/index.js